<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'app',
		components: {

		}
	}
</script>

<style>
	body ,p{
		margin: 0;
		padding: 0;
	}
	
	#app {
		margin: 0;
		padding: 0;
	}
	.el-input__inner{
		height: 50px!important;
		outline: none!important;
	}
	.el-table .cell{
		line-height:30px!important;
	}
	.el-descriptions :not(.is-bordered) .el-descriptions-item__cell{
		width: 17%!important;
	}

	.el-message__icon{
		font-size: 35px!important;
	}
	.el-message__content{
		font-size: 35px!important;
		font-weight: bold;
	}
</style>
